import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { get } from './actions';

export interface EndpointStatusState {
  loaded: boolean;
  status: string;
}

const initialState: EndpointStatusState = {
  loaded: false,
  status: ''
};

const reducer = reducerWithInitialState(initialState)
  .case(get.started, (state) => {
    return { ...state, loaded: false };
  })
  .case(get.done, (state, param) => {
    return { ...state, loaded: true, status: param.result.status};
  })
  .case(get.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })
;

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/endpointStatus/reducers.ts